import { render } from "./BaseSelectBox.vue?vue&type=template&id=846865f2&scoped=true"
import script from "./BaseSelectBox.vue?vue&type=script&lang=js"
export * from "./BaseSelectBox.vue?vue&type=script&lang=js"

import "./BaseSelectBox.vue?vue&type=style&index=0&id=846865f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-846865f2"]])

export default __exports__